export default __webpack_public_path__ + "static/media/iresha.b4880803.jpg";